import React from 'react';
import { CheckIcon } from 'lucide-react';
import { isThis } from '../data/copy';
export function SolutionSection() {
  return <section className="w-full bg-ivory py-10 sm:py-12" aria-labelledby="solution-heading" data-id="element-176" data-mp="3aaud1j8wphh0">
      <div className="mx-auto max-w-5xl px-6" data-id="element-177" data-mp="3oabsv9485ke8">
        <div className="rounded-4xl border border-line bg-shell px-7 py-10 shadow-soft sm:px-12" data-id="element-178" data-mp="3o6xuebyolvc2">
          <div className="text-center" data-id="element-179" data-mp="3jck42nyvmee9">
            <p className="flex items-center justify-center gap-4 font-sans text-[11px] font-semibold uppercase tracking-[0.24em] text-gold-ink" data-id="element-180" data-mp="13t3vznth7x0">
              <span className="h-px w-10 bg-gold/60" aria-hidden="true" data-id="element-181" data-mp="3t6ap1ivso6p7" />
              Introducing
              <span className="h-px w-10 bg-gold/60" aria-hidden="true" data-id="element-182" data-mp="awi7y9h1fjib" />
            </p>

            <h2 id="solution-heading" className="mt-6 font-display text-[2rem] leading-[1.08] text-ink sm:text-[2.75rem]" data-id="element-183" data-mp="5w2w5mcemk2g">
              Yoga Teaching Vault™
            </h2>
            <p className="mx-auto mt-3 max-w-xl font-display text-xl leading-snug text-sage" data-id="element-184" data-mp="fus52pmbou6k">
              Your complete ready-to-teach yoga class system.
            </p>
            <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-185" data-mp="3b972dgc1l7pr">
              A digital teaching library — 6 volumes, 7 bonuses — built to sit
              beside you while you teach.
            </p>
          </div>

          <ul className="mx-auto mt-8 grid max-w-3xl gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-186" data-mp="3k8akagzh3h2o">
            {isThis.map(item => <li key={item} className="flex items-start gap-3 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-187" data-mp="3p7nj803mcelm">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={2.4} aria-hidden="true" data-id="element-188" data-mp="2u5hgcbb5tyz" />
                {item}
              </li>)}
          </ul>

          <p className="mt-8 text-center font-display text-lg tracking-[0.18em] text-gold-ink" data-id="element-189" data-mp="6uphbnn9nbot">
            LESS BUILDING. MORE TEACHING.
          </p>
        </div>
      </div>
    </section>;
}